<script setup lang="ts">
import type {VariantProps} from 'class-variance-authority'
import type {ToggleGroupRootEmits, ToggleGroupRootProps} from 'reka-ui'
import type {HTMLAttributes} from 'vue'
import type {toggleVariants} from '@/components/ui/toggle'
import {reactiveOmit} from '@vueuse/core'
import {ToggleGroupRoot, useForwardPropsEmits} from 'reka-ui'
import {provide} from 'vue'
import {cn} from '@/lib/utils'

type ToggleGroupVariants = VariantProps<typeof toggleVariants>

const props = defineProps<
  ToggleGroupRootProps & {
    class?: HTMLAttributes['class']
    variant?: ToggleGroupVariants['variant']
    size?: ToggleGroupVariants['size']
  }
>()
const emits = defineEmits<ToggleGroupRootEmits>()

provide('toggleGroup', {
  variant: props.variant,
  size: props.size,
})

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <ToggleGroupRoot
    v-slot="slotProps"
    v-bind="forwarded"
    :class="cn('flex items-center justify-center gap-1', props.class)">
    <slot v-bind="slotProps" />
  </ToggleGroupRoot>
</template>
